// extracted by css-extract-rspack-plugin
export default {"lastEditedInfoText":"w5pfT"};